import client from '@/api/client'

export async function logToDatadog(message: string) {
    await client.post('/log', null, {
        params: {
            message,
        },
    })
}
